import { SymbolInfo } from 'symbols/symbolInfo/symbolInfoSlice';
import { buildFiltersFunction } from 'utils/filter/functions/filtersFunction';
import { FilterState } from 'widgets/store/grid/filters/FilterState';
import {
    symbolInfoColumnDefinitionDictionary,
    SymbolInfoColumns,
} from 'symbols/symbolInfo/columns';
import { ExactSign } from 'utils/filter/filter';
import { ValueType } from '@instinet-analytics/semantic-ui-components';
import pluralize from 'pluralize';
import {
    DefaultFallback,
    IndexMapping,
} from 'symbols/indexMappings/store/IndexMappingsState';

export const indexMappingsToString = (mappings: IndexMapping[] | undefined) => {
    if (!mappings || mappings.length === 0) {
        return 'None configured - will use default';
    }

    return `${mappings.length} ${pluralize('mapping', mappings.length)}`;
};

export function mapSymbol(
    configuredFallbackInstinetIndex: string | undefined,
    mappings: IndexMapping[],
    symbol: SymbolInfo,
    exchangeRate: number
): { index: string; usedConfigFallback: boolean } {
    for (const mapping of mappings) {
        const { attribute, value, index } = mapping;

        if (
            symbolPassesMappingCriteria(attribute, value, symbol, exchangeRate)
        ) {
            return { index, usedConfigFallback: false };
        }
    }

    return configuredFallbackInstinetIndex &&
        configuredFallbackInstinetIndex !== ''
        ? { index: configuredFallbackInstinetIndex, usedConfigFallback: true }
        : { index: DefaultFallback, usedConfigFallback: false };
}

function symbolPassesMappingCriteria(
    attribute: SymbolInfoColumns,
    value: string,
    symbol: SymbolInfo,
    exchangeRate: number
) {
    const filter: FilterState<SymbolInfoColumns> = {
        column: attribute,
        filter: { exactSign: ExactSign.EQ, value, valueType: ValueType.STRING },
    };
    const filterFn = buildFiltersFunction(
        symbolInfoColumnDefinitionDictionary,
        [filter],
        exchangeRate
    );

    return filterFn(symbol);
}
